import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  fields: {
    minHeight: "6.25rem",
    marginBottom: "2rem",
  },
  noData: {
    color: "#383F51",
  },
  titleContainer: {
    padding: 0,
  },
  title: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#383F51",
    fontFamily: "Roboto",
    fontSize: 20,
    fontWeight: 500,
  },
  divider: {
    marginBottom: 10,
    marginTop: 10,
  },
  button: {
    zIndex: 1,
  },
}));

export const styles = {
  option: {
    marginRight: 10,
  },
  options: {
    display: "flex",
    flexWrap: "wrap",
  },
};
